import { APIMethod, fetchData } from "@client";
import { mapKeysToSnakeCase } from "@client/api/utils/fetchApiUtils";

export async function reorderCompanyRateCardRoles(categoryId, roleId, newOrder, oldOrder) {
  return await fetchData(
    `/company/rate-card/categories/${categoryId}/roles/order`,
    APIMethod.PATCH,
    {
      isJSONData: true,
      data: mapKeysToSnakeCase({
        roleId,
        newOrder,
        direction: oldOrder > newOrder ? "up" : "down",
      }),
    }
  );
}
